// @flow
import * as React from 'react';
import Box from 'sail/Box';
import Card from 'sail/Card';
import {CodeBlock, OnlyRenderOnClient} from 'docs/components';
import {componentToExamples} from './examples';
import type {TailorComponentName} from './examples';
import './TailorExample.scss';

type TailorExampleProps = {|
  component: TailorComponentName,
  children: React.Node,
  example: string,
  hideSourceCode: boolean,
|};

// This is a WIP. See http://go/tailor-docs-journal

export const TailorExample = ({
  component,
  children,
  example,
  hideSourceCode = false,
}: TailorExampleProps) => {
  const {rendered, source} =
    componentToExamples[component] && componentToExamples[component][example]
      ? componentToExamples[component][example]
      : {};

  if (!rendered || !source) {
    return null;
  }

  return (
    <Box className="ComponentExample" margin={{top: 24, bottom: 64}}>
      <Box>
        <Card radius="bottom" shadow="keyline">
          <Box padding={{all: 20}}>
            <OnlyRenderOnClient>{rendered}</OnlyRenderOnClient>
          </Box>
        </Card>
      </Box>
      {!hideSourceCode && (
        <Box className="ComponentExample-CodeContainer">
          <CodeBlock numbered={false} filename="Source" language="jsx">
            {`${source}\n`}
          </CodeBlock>
        </Box>
      )}
    </Box>
  );
};
